/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class oxygenequipmenttype extends IceEntity {
  oxygen_equipment_type_key: string = "";
  oxygen_equipment_type_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  tablename: string = "";

  constructor(tbname: string) {
    super();
    this.tablename = tbname;
  }

  gettablename(): string {
    return this.tablename;
  }
}
